module.exports = __webpack_public_path__ + "img/noResult1.d985d0fc.png";